export class PMOEditTeamModel {
    constructor() {
        this.id = "";
        this.clientId = "";
        this.name = "";
        // @Type(() => PMOTeamMemberModel)
        // teamMembers?: IPMOTeamMemberDTO[] = [];
    }
}
export default class PMOEditTeam extends PMOEditTeamModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
